module.exports = __webpack_public_path__ + "static/media/bsm-logo-single-white.8fa4f7c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bsm-logo-single-white.png
// module id = 714
// module chunks = 0